import { ScenarioTransferType } from '@/shared/api/types';
import { SJCollection } from '@/shared/lib/sj-orm';
import { BeneficiaryDto } from '@/shared/lib/sj-orm/models/beneficiary.dto';
import { CollectionName } from '@/shared/lib/sj-orm/types';

import { Step2DataForm } from '../types/form';

type BeneficiaryFormattedData = {
  centralDbId: number;
  publicKey: string | undefined;
  dtoId: string;
};

type BeneficiaryData = {
  id: number;
  publicKey?: string | null;
};

export type BeneficiariesDataMap = { [beneficiaryDtoId: string]: BeneficiaryFormattedData };

export const getBeneficiariesDataMap = ({
  step2,
  beneficiariesCollection,
  beneficiariesData,
}: {
  step2: Step2DataForm;
  beneficiariesCollection: SJCollection<CollectionName.BENEFICIARIES, BeneficiaryDto>;
  beneficiariesData: BeneficiaryData[];
}): BeneficiariesDataMap => {
  const beneficiariesIdsList =
    step2.transferType === ScenarioTransferType.AllAtOnce
      ? step2.beneficiaryIds
      : [step2.sequence1, step2.sequence2, step2.sequence3, step2.sequence4]
          .filter((el) => el !== undefined && el !== null)
          .flat();

  const uniqBeneficiariesList = Array.from(new Set(beneficiariesIdsList));

  const beneficiariesDataMap = uniqBeneficiariesList.reduce<BeneficiariesDataMap>((acc, dtoId) => {
    const centralDbId = beneficiariesCollection.findById(dtoId)?.centralDbProfileId;

    const beneficiaryData = beneficiariesData.find((beneficiary) => beneficiary.id === centralDbId);

    if (beneficiaryData && centralDbId) {
      acc[dtoId] = {
        centralDbId,
        publicKey: beneficiaryData.publicKey ?? undefined,
        dtoId,
      };
    }

    return acc;
  }, {});

  return beneficiariesDataMap;
};
